<div>
    <img src="../../../../../../../../assets/images/popup-recipient/cancel.svg" (click)="delete()" />
    <input placeholder="{{ 'questionBoard.edit.placeholder' | translate }}"
        [formControl]="tablePartForm.controls.title">
</div>